<script>
import CompanyTabLayout from '@/components/company/CompanyTabLayout.vue';
import CollectionsList from '@/pages/collections/CollectionsList.vue';

export default {
  components: {
    CompanyTabLayout,
    CollectionsList,
  },
};
</script>

<template>
  <CompanyTabLayout active-tab="product-collections" v-slot="{ companyId }">
    <CollectionsList :company-id="companyId" view-mode="collections" />
  </CompanyTabLayout>
</template>
